const Global = {
  init: () => {
    // setup global click handler
    window.addEventListener("click", Global.clickHandler);

    // focus form message
    Global.focusFormMessage();
  },

  getElements: (selector) => {
    return Array.from(document.querySelectorAll(selector));
  },

  closeAll: (list) => {
    if (list) {
      list.forEach((item) => {
        if (item.hasAttribute("aria-expanded")) {
          item.setAttribute("aria-expanded", "false");
        }

        item.classList.remove("is-expanded");
      });
    }
  },

  clickHandler: (e) => {
    const elTarget = e.target;

    // close all share dialogues
    if (!elTarget.classList.contains("btn--share")) {
      const shareBtns = Global.getElements(".btn--share");
      if (shareBtns) Global.closeAll(shareBtns);
    }

    // close sub menus
    if (
      !elTarget.closest(".menu-item-has-children") &&
      !elTarget.closest(".main-header__btn-mobile-nav")
    ) {
      // clicking outside navs
      const navs = Global.getElements(
        ".main-header [aria-expanded='true'], .main-header .is-expanded"
      );
      if (navs) Global.closeAll(navs);
    }
  },

  // focus login username input field
  focusUsernameInput: () => {
    const username_input = document.getElementById("user_login");
    if (username_input) username_input.focus();
  },

  // focus on form messages
  focusFormMessage: () => {
    const formMessage = document.querySelector(".form__row--is-message");
    if (formMessage) {
      setTimeout(function () {
        formMessage.focus();
      }, 300);
    } else {
      // focus username input field
      Global.focusUsernameInput();
    }
  },
};

export default Global;
